export const accountVariables = [
  {
    _id: "sd_0",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "image",
      name: "sender_picture",
      title: "Sender picture",
      default:
        "https://assets.storydoc.com/5d7d8922e00d9265/37a739ee-ccf6-4aed-9e4d-4a82e0469ace",
      tip: "Account picture",
      validation: { required: false },
    },
  },
  {
    _id: "sd_1",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_name",
      title: "Sender name",
      default: "",
      tip: "Account name",
      validation: { required: false },
    },
  },
  {
    _id: "sd_2",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_email",
      title: "Sender email",
      default: "",
      tip: "Account email",
      validation: { required: false },
    },
  },
  {
    _id: "sd_3",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_calendar",
      title: "Sender calendar link",
      default: "",
      tip: "Account calendar link",
      validation: { required: false },
    },
  },
  {
    _id: "sd_4",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_role",
      title: "Sender role",
      default: "",
      tip: "Sender role",
      validation: { required: false },
    },
  },
  {
    _id: "sd_5",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_phone",
      title: "Sender phone",
      default: "",
      tip: "Sender phone",
      validation: { required: false },
    },
  },
  {
    _id: "sd_8",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_department",
      title: "Sender department",
      default: "",
      tip: "Sender department",
      validation: { required: false },
    },
  },
  {
    _id: "sd_9",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_website",
      title: "Sender website",
      default: "",
      tip: "Sender website",
      validation: { required: false },
    },
  },
  {
    _id: "sd_11",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_linkedin",
      title: "Sender LinkedIn",
      default: "",
      tip: "Sender LinkedIn",
      validation: { required: false },
    },
  },
  {
    _id: "sd_12",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_location",
      title: "Sender location",
      default: "",
      tip: "Sender location",
      validation: { required: false },
    },
  },
  {
    _id: "sd_13",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "sender_address",
      title: "Sender address",
      default: "",
      tip: "Sender address",
      validation: { required: false },
    },
  },
  {
    _id: "sd_10",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "image",
      name: "sender_signature",
      title: "Sender signature",
      default: "",
      tip: "Sender signature",
      validation: { required: false },
    },
  },
  {
    _id: "sd_6",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "image",
      name: "organization_logo",
      title: "Your company's logo",
      default:
        "https://assets.storydoc.com/5d7d8922e00d9265/37a739ee-ccf6-4aed-9e4d-4a82e0469ace",
      tip: "Organization logo",
      validation: { required: false },
    },
  },
  {
    _id: "sd_7",
    plan: "trial",
    variable: {
      tab: "Content",
      group: "Account",
      type: "input",
      name: "organization_website",
      title: "Your company's website",
      default: "",
      tip: "Organization website",
      validation: { required: false },
    },
  },
];
